<template>
	<!-- CZ 13·14절: 신규 매수문의. 등록하면 PASS 직원에게 순번대로 배정되고 그 직원의 관리고객 카드가 만들어진다.
	     PASS 직원이 없으면 배정 대기로 남고, 관리자가 사유를 적어 직접 배정한다(사용자 결정 2026-10-12).
	     DC: 관리자와 매수배정 담당(KPI·배정 설정의 팀장 배정 탭에서 켠 팀장)이 쓴다. 판정은 서버(/lead/meta 의 canLead)다. -->
	<div class="content lead-admin" v-if="allowed">
		<div class="section">
			<div class="section-tit">
				신규 매수문의 등록
				<span class="sub">홈페이지·전화·광고로 들어온 매수 문의를 적으면 순번대로 담당자가 정해집니다</span>
			</div>
			<table class="table type-input">
				<colgroup><col width="130" /><col /><col width="130" /><col /></colgroup>
				<tr>
					<th>고객명 <span class="txt-c--red">*</span></th>
					<td><input type="text" class="form-control" maxlength="50" v-model="form.name" /></td>
					<th>연락처</th>
					<td><input type="text" class="form-control" maxlength="20" :value="form.mobile" @input="onPhone" placeholder="숫자만 입력해도 됩니다" /></td>
				</tr>
				<tr>
					<th>유입경로 <span class="txt-c--red">*</span></th>
					<td class="la-inline">
						<select class="form-control select" v-model="form.source">
							<option value="">선택</option>
							<option v-for="(label, k) in sources" :key="'s_' + k" :value="k">{{ label }}</option>
						</select>
						<input type="text" class="form-control" maxlength="100" placeholder="상세(캠페인·소개자 등)" v-model="form.sourceDetail" />
					</td>
					<th>문의 일시</th>
					<td><input type="datetime-local" class="form-control" v-model="form.occurredAt" /></td>
				</tr>
				<tr>
					<th>희망 금액</th>
					<td class="la-inline">
						<input type="number" class="form-control" min="0" placeholder="최소(억)" v-model="form.findMoneyS" />
						<span>~</span>
						<input type="number" class="form-control" min="0" placeholder="최대(억)" v-model="form.findMoneyE" />
					</td>
					<th>희망 지역</th>
					<td><input type="text" class="form-control" maxlength="50" v-model="form.findArea" /></td>
				</tr>
				<tr>
					<th>문의 내용</th>
					<td colspan="3"><textarea class="form-control" rows="2" maxlength="2000" v-model="form.memo"></textarea></td>
				</tr>
			</table>
			<div class="btn-wrap la-actions">
				<label class="input-checkbox">
					<input type="checkbox" v-model="form.autoAssign" />
					<span class="checkbox"></span>
					<span class="text">등록과 함께 순번 배정</span>
				</label>
				<button type="button" class="btn btn-sm btn-secondary" :disabled="busy" @click="resetForm">비우기</button>
				<button type="button" class="btn btn-sm btn-primary" :disabled="busy" @click="submit">{{ busy ? '등록 중' : '등록' }}</button>
			</div>
		</div>

		<div class="section">
			<div class="section-tit">
				신규 매수문의
				<span v-if="unhandledHours" class="sub">첫 연락 기한 {{ unhandledHours }}시간 · 기한이 지나도 상담이 없으면 그 담당자는 다음 배정에서 HOLD 됩니다</span>
				<span v-else class="sub">첫 연락 기한을 쓰지 않습니다(KPI·배정 설정)</span>
				<div class="right" v-if="isAdmin">
					<router-link class="btn btn-sm btn-light" to="/SystemAdmin/SystemAdmin19">배정 설정</router-link>
				</div>
			</div>
			<div class="la-chips">
				<button
					v-for="s in STATUS"
					:key="'st_' + s.value"
					type="button"
					class="btn btn-xsm"
					v-bind:class="status === s.value ? 'btn-secondary' : 'btn-outline-secondary'"
					@click="setStatus(s.value)"
				>
					{{ s.value && counts[s.value] ? `${s.label} ${counts[s.value]}` : s.label }}
				</button>
			</div>
			<div class="table-wrap">
				<table class="table la-table">
					<tr>
						<th>번호</th>
						<th>문의 일시</th>
						<th>유입경로</th>
						<th>고객</th>
						<th>연락처</th>
						<th>상태</th>
						<th>담당자</th>
						<th>배정</th>
						<th>첫 연락</th>
						<th></th>
					</tr>
					<tr v-for="l in list" :key="'l_' + l.lead_uid">
						<td>{{ l.lead_uid }}</td>
						<td>{{ l.occurred_at }}</td>
						<td>{{ l.source_label }}<span v-if="l.source_detail" class="la-sub d-block">{{ l.source_detail }}</span></td>
						<td class="txt-left">
							<a v-if="l.client_uid" href="#" @click.prevent="openClient(l.client_uid)"><b>{{ l.name }}</b></a>
							<b v-else>{{ l.name }}</b>
							<span v-if="l.memo" class="la-sub d-block la-memo">{{ l.memo }}</span>
						</td>
						<td>{{ l.mobile || '-' }}</td>
						<td>
							<span v-bind:class="statusClass(l)">{{ statusLabel(l) }}</span>
							<span v-if="l.status === 'dup'" class="la-sub d-block">담당 {{ l.client_mgr_name || '-' }}</span>
							<span v-if="l.status === 'closed' && l.close_reason" class="la-sub d-block">{{ l.close_reason }}</span>
						</td>
						<td>{{ l.assigned_name || '-' }}</td>
						<td>{{ l.assigned_at || '-' }}</td>
						<td>
							<span v-if="l.first_contact_at">{{ l.first_contact_at }}</span>
							<span v-else-if="l.unhandled" class="txt-c--red">기한 지남</span>
							<span v-else-if="l.status === 'assigned'" class="txt-c--grey">대기</span>
							<span v-else>-</span>
						</td>
						<td class="la-btns">
							<button v-if="l.status === 'waiting'" type="button" class="btn btn-xxsm btn-primary" :disabled="busy" @click="autoAssign(l)">순번 배정</button>
							<button v-if="l.status === 'waiting' || l.status === 'assigned'" type="button" class="btn btn-xxsm btn-light" :disabled="busy" @click="openManual(l)">
								{{ l.status === 'assigned' ? '재배정' : '직접 배정' }}
							</button>
							<button v-if="l.status !== 'closed'" type="button" class="btn btn-xxsm btn-light" :disabled="busy" @click="openClose(l)">종결</button>
							<button type="button" class="btn btn-xxsm btn-light" @click="openLog(l)">이력</button>
						</td>
					</tr>
					<tr v-if="loaded && !list.length">
						<td colspan="10">등록된 문의가 없습니다.</td>
					</tr>
				</table>
			</div>
		</div>

		<!-- DC: 지금 배정 후보. 매수배정 담당도 누가 받을 수 있고 누가 왜 HOLD 인지 본다(설정은 관리자만 바꾼다). -->
		<div class="section">
			<div class="section-tit">
				배정 후보
				<span class="sub">다음 차례: {{ nextName || '없음(배정 대기)' }}</span>
			</div>
			<div class="table-wrap">
				<table class="table la-pool">
					<tr>
						<th>순번</th>
						<th>직원</th>
						<th>팀/직급</th>
						<th>상태</th>
						<th>사유</th>
					</tr>
					<tr v-for="m in poolRows" :key="'po_' + m.mem_uid">
						<td>{{ m.rotation ? m.rotation.pos : '-' }}</td>
						<td class="txt-left"><b>{{ m.mem_name }}</b></td>
						<td class="la-sub">{{ m.team_name || '-' }} / {{ m.rank_name || '-' }}</td>
						<td><span v-bind:class="statusTone(m.status)">{{ m.status === 'OFF' ? '배정 대상 아님' : m.status }}</span></td>
						<td class="txt-left la-sub">{{ m.reasons.map((r) => r.text).join(', ') || '-' }}</td>
					</tr>
					<tr v-if="poolLoaded && !poolRows.length">
						<td colspan="5">배정 대상인 직원이 없습니다.</td>
					</tr>
				</table>
			</div>
		</div>

		<!-- 직접 배정·재배정 -->
		<div v-if="manual" class="popup-wrap">
			<div class="dim" @click="manual = null"></div>
			<div class="popup md">
				<div class="popup-tit">
					{{ manual.lead.name }} {{ manual.lead.status === 'assigned' ? '재배정' : '직접 배정' }}
					<button type="button" class="btn btn-close" @click="manual = null"><b-icon-x-lg /></button>
				</div>
				<div class="popup-con">
					<div class="txt-c--grey mb-1">
						※ 직접 배정은 순번을 쓰지 않습니다. HOLD 인 직원에게도 줄 수 있지만 그 사실과 사유가 이력에 남습니다.
						<template v-if="manual.lead.client_uid">이미 만든 고객카드의 담당자가 바뀌고 고객 변경내역에도 남습니다.</template>
					</div>
					<div class="table-wrap la-pick">
						<table class="table click">
							<tr>
								<th></th>
								<th>직원</th>
								<th>상태</th>
								<th>사유</th>
							</tr>
							<tr v-for="m in pickList" :key="'pm_' + m.mem_uid" @click="manual.memUid = m.mem_uid" v-bind:class="{ 'la-on': manual.memUid === m.mem_uid }">
								<td><input type="radio" :checked="manual.memUid === m.mem_uid" /></td>
								<td class="txt-left">{{ m.mem_name }} <span class="la-sub">{{ m.rank_name || '' }}</span></td>
								<td><span v-bind:class="statusTone(m.status)">{{ m.status === 'OFF' ? '배정 대상 아님' : m.status }}</span></td>
								<td class="txt-left la-sub">{{ m.reasons.map((r) => r.text).join(', ') || '-' }}</td>
							</tr>
						</table>
					</div>
					<table class="table type-input">
						<colgroup><col width="25%" /><col width="75%" /></colgroup>
						<tr>
							<th>사유 <span class="txt-c--red">*</span></th>
							<td><input type="text" class="form-control" maxlength="300" placeholder="예: 고객이 이전 상담 직원을 원함" v-model="manual.reason" /></td>
						</tr>
					</table>
					<div class="btn-wrap">
						<button type="button" class="btn btn-sm btn-secondary" @click="manual = null">취소</button>
						<button type="button" class="btn btn-sm btn-primary" :disabled="busy" @click="saveManual">배정</button>
					</div>
				</div>
			</div>
		</div>

		<!-- 종결 -->
		<div v-if="closing" class="popup-wrap">
			<div class="dim" @click="closing = null"></div>
			<div class="popup sm">
				<div class="popup-tit">
					{{ closing.name }} 종결
					<button type="button" class="btn btn-close" @click="closing = null"><b-icon-x-lg /></button>
				</div>
				<div class="popup-con">
					<table class="table type-input">
						<colgroup><col width="25%" /><col width="75%" /></colgroup>
						<tr>
							<th>사유 <span class="txt-c--red">*</span></th>
							<td><input type="text" class="form-control" maxlength="200" placeholder="예: 장난 문의, 매도 문의로 확인" v-model="closing.reason" /></td>
						</tr>
					</table>
					<div class="txt-c--grey">※ 종결해도 이미 만든 고객카드는 지우지 않습니다.</div>
					<div class="btn-wrap">
						<button type="button" class="btn btn-sm btn-secondary" @click="closing = null">취소</button>
						<button type="button" class="btn btn-sm btn-danger" :disabled="busy" @click="saveClose">종결</button>
					</div>
				</div>
			</div>
		</div>

		<!-- 배정 이력 -->
		<div v-if="logView" class="popup-wrap">
			<div class="dim" @click="logView = null"></div>
			<div class="popup lg">
				<div class="popup-tit">
					{{ logView.lead.name }} 배정 이력
					<button type="button" class="btn btn-close" @click="logView = null"><b-icon-x-lg /></button>
				</div>
				<div class="popup-con">
					<div class="table-wrap">
						<table class="table la-log">
							<tr>
								<th>시각</th>
								<th>방식</th>
								<th>첫 후보</th>
								<th>배정</th>
								<th>이전 담당</th>
								<th>건너뛴 직원</th>
								<th>처리</th>
								<th>사유</th>
							</tr>
							<tr v-for="g in logView.list" :key="'lg_' + g.log_uid">
								<td>{{ g.at }}</td>
								<td>{{ MODE[g.mode] || g.mode }}<span v-if="g.is_reassign === 'Y'" class="la-sub d-block">재배정</span></td>
								<td>{{ g.first_candidate_name || '-' }}</td>
								<td><b>{{ g.assigned_name || '-' }}</b></td>
								<td>{{ g.prev_name || '-' }}</td>
								<td class="txt-left">
									<div v-for="s in g.skipped" :key="'sk_' + g.log_uid + s.mem_uid">
										{{ s.name }} <span class="la-sub">{{ s.reasons.join(', ') }}</span>
									</div>
									<span v-if="!g.skipped.length">-</span>
								</td>
								<td>{{ g.changed_by_name || '시스템' }}</td>
								<td class="txt-left">{{ g.reason || '-' }}</td>
							</tr>
						</table>
					</div>
					<div class="btn-wrap">
						<button type="button" class="btn btn-sm btn-secondary" @click="logView = null">닫기</button>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="content lead-admin" v-else-if="metaFailed">
		<div class="section">
			<div class="section-tit">신규 매수문의</div>
			<p class="txt-c--grey">권한을 확인하지 못했습니다(서버 응답 없음).
				<button type="button" class="btn btn-xxsm btn-light" @click="enter">다시 시도</button>
			</p>
		</div>
	</div>
</template>

<script>
import { formatPhone } from '@/utils/phone.mjs';

const STATUS = [
	{ value: '', label: '전체' },
	{ value: 'waiting', label: '배정 대기' },
	{ value: 'assigned', label: '배정됨' },
	{ value: 'dup', label: '기존 고객' },
	{ value: 'closed', label: '종결' },
];
const MODE = { auto: '순번', manual: '직접', wait: '대기', dup: '기존 고객', close: '종결' };

function nowLocal() {
	return new Date(Date.now() + 9 * 3600 * 1000).toISOString().slice(0, 16);
}
function newKey() {
	// 운영은 http(비보안 컨텍스트)라 crypto.randomUUID 가 없다.
	if (window.crypto && typeof window.crypto.randomUUID === 'function') return window.crypto.randomUUID().replace(/-/g, '');
	return Date.now().toString(36) + Math.random().toString(36).slice(2, 12);
}
function emptyForm() {
	return {
		name: '', mobile: '', source: '', sourceDetail: '', occurredAt: nowLocal(),
		findMoneyS: '', findMoneyE: '', findArea: '', memo: '', autoAssign: true, clientKey: newKey(),
	};
}

export default {
	name: 'LeadAdmin',
	data() {
		return {
			STATUS,
			MODE,
			busy: false,
			loaded: false,
			allowed: false,
			metaFailed: false,
			left: false,
			isAdmin: false,
			poolLoaded: false,
			nextUid: null,
			sources: {},
			form: emptyForm(),
			status: '',
			list: [],
			counts: {},
			unhandledHours: 24,
			members: [],
			manual: null,
			closing: null,
			logView: null,
		};
	},
	computed: {
		// 직접 배정 후보: 지금 받을 수 있는 사람(PASS)이 위로 오게 한다.
		pickList() {
			const rank = { PASS: 0, HOLD: 1, OFF: 2 };
			return [...this.members].sort((a, b) => (rank[a.status] - rank[b.status]) || a.mem_name.localeCompare(b.mem_name, 'ko'));
		},
		// 배정 후보 표: 배정 대상을 켠 사람만, 순번대로.
		poolRows() {
			return this.members.filter((m) => m.assign_on)
				.sort((a, b) => ((a.rotation ? a.rotation.pos : 999) - (b.rotation ? b.rotation.pos : 999)) || a.mem_name.localeCompare(b.mem_name, 'ko'));
		},
		nextName() {
			const m = this.members.find((x) => x.mem_uid === this.nextUid);
			return m ? m.mem_name : '';
		},
	},
	created() {
		this.enter();
	},
	beforeUnmount() {
		this.left = true;
	},
	methods: {
		// 권한(관리자 또는 매수배정 담당)은 서버가 정한다. 라우터는 이 값을 모르므로 화면이 먼저 묻고 그린다.
		// 응답 실패와 '권한 없음' 을 가른다(codex 리뷰): 로그인 만료(401)면 API 계층이 이미 로그인으로 보냈고, 그 사이
		// 다른 화면으로 떠났으면 늦은 응답이 지금 화면을 대시보드로 돌리지 않는다.
		async enter() {
			this.metaFailed = false;
			const ok = await this.loadMeta();
			if (this.left) return;
			if (ok === 'error') {
				if (this.$isAuthRedirect()) return;
				this.metaFailed = true;
				return;
			}
			if (ok !== 'yes') {
				alert('관리자 또는 매수배정 담당만 쓸 수 있습니다.');
				this.$router.replace({ name: 'MainDashboard' });
				return;
			}
			this.allowed = true;
			this.load();
			this.loadMembers();
		},
		onPhone(e) {
			this.form.mobile = formatPhone(e.target.value);
			e.target.value = this.form.mobile;
		},
		resetForm() {
			this.form = emptyForm();
		},
		async loadMeta() {
			const re = await this.$apiGET('/admin/api/lead/meta');
			if (!re || !re.sources) return 'error';
			this.sources = re.sources;
			this.isAdmin = !!re.isAdmin;
			return re.canLead ? 'yes' : 'no';
		},
		statusTone(s) {
			return { PASS: 'la-ok', HOLD: 'txt-c--red', OFF: 'txt-c--grey' }[s] || '';
		},
		async load() {
			const re = await this.$apiGET('/admin/api/lead/list' + (this.status ? '?status=' + this.status : ''));
			if (!re || !re.list) return;
			this.list = re.list;
			this.counts = re.counts || {};
			this.unhandledHours = re.unhandled_hours;
			this.loaded = true;
		},
		setStatus(s) {
			this.status = s;
			this.load();
		},
		statusLabel(l) {
			return { waiting: '배정 대기', assigned: '배정됨', dup: '기존 고객', closed: '종결' }[l.status] || l.status;
		},
		statusClass(l) {
			return { waiting: 'txt-c--red', assigned: 'la-ok', dup: 'txt-c--grey', closed: 'txt-c--grey' }[l.status] || '';
		},
		async submit() {
			const f = this.form;
			if (!f.name.trim()) return alert('고객명을 입력하세요.');
			if (!f.source) return alert('유입경로를 고르세요.');
			this.busy = true;
			try {
				const re = await this.$apiPOST('/admin/api/lead/add', { ...f, occurredAt: f.occurredAt ? f.occurredAt.replace('T', ' ') : '' });
				if (!re || !re.ok) return;
				alert(this.resultText(re));
				this.resetForm();
				this.load();
				this.loadMembers();
			} finally {
				this.busy = false;
			}
		},
		resultText(re) {
			if (re.replay) return '이미 등록된 문의입니다(같은 요청이 두 번 들어왔습니다).';
			if (re.dup) return `연락처가 같은 매수고객이 이미 있습니다(담당 ${re.dup.mgr_name || '없음'}). 새 고객카드를 만들지 않고 '기존 고객' 으로 두었습니다.`;
			const a = re.assign || re;
			if (!a || !a.status) return '등록했습니다. 아직 배정하지 않았습니다.';
			if (a.status === 'assigned') return `${a.assignedName || '담당자'}에게 배정하고 고객카드를 만들었습니다.`;
			if (a.status === 'waiting') return '지금 배정할 수 있는(PASS) 직원이 없어 배정 대기로 두었습니다. 사유를 적고 직접 배정해 주세요.';
			if (a.status === 'dup') return '배정 중 같은 연락처의 매수고객이 확인되어 기존 고객으로 두었습니다.';
			return '처리했습니다.';
		},
		async loadMembers() {
			const re = await this.$apiGET('/admin/api/lead/pool');
			if (!re || !re.list) return;
			this.members = re.list;
			this.nextUid = re.rotation ? re.rotation.next : null;
			this.poolLoaded = true;
		},
		async autoAssign(l) {
			this.busy = true;
			try {
				const re = await this.$apiPOST('/admin/api/lead/assign', { leadUid: l.lead_uid });
				if (!re || !re.ok) return;
				alert(this.resultText(re));
				this.load();
				this.loadMembers();
			} finally {
				this.busy = false;
			}
		},
		async openManual(l) {
			await this.loadMembers();
			this.manual = { lead: l, memUid: null, reason: '' };
		},
		async saveManual() {
			const m = this.manual;
			if (!m.memUid) return alert('직원을 고르세요.');
			if (!m.reason.trim()) return alert('사유를 입력하세요.');
			this.busy = true;
			try {
				const re = await this.$apiPOST('/admin/api/lead/assign', { leadUid: m.lead.lead_uid, memUid: m.memUid, reason: m.reason });
				if (!re || !re.ok) return;
				this.manual = null;
				this.load();
				this.loadMembers();
			} finally {
				this.busy = false;
			}
		},
		openClose(l) {
			this.closing = { lead_uid: l.lead_uid, name: l.name, reason: '' };
		},
		async saveClose() {
			const c = this.closing;
			if (!c.reason.trim()) return alert('사유를 입력하세요.');
			this.busy = true;
			try {
				const re = await this.$apiPOST('/admin/api/lead/close', { leadUid: c.lead_uid, reason: c.reason });
				if (!re || !re.ok) return;
				this.closing = null;
				this.load();
				this.loadMembers();   // 미처리 문의가 풀려 HOLD 가 PASS 로 바뀌고 다음 차례가 달라질 수 있다
			} finally {
				this.busy = false;
			}
		},
		async openLog(l) {
			const re = await this.$apiGET('/admin/api/lead/log?leadUid=' + l.lead_uid);
			if (!re || !re.list) return;
			this.logView = { lead: l, list: re.list };
		},
		openClient(cid) {
			const w = window.screen.availWidth;
			const h = window.screen.availHeight;
			window.open('/UserDetail/' + cid, '', `width=${w}, height=${h}, resizable=no, status=no`);
		},
	},
};
</script>

<style lang="scss">
@import "@/assets/css/design-tokens.scss";

.lead-admin {
	// 공통 규칙 .table td(가운데 정렬)가 단일 클래스 .txt-left 보다 앞선다.
	.table td.txt-left {
		text-align: left;
	}
	.la-inline {
		display: flex;
		align-items: center;
		gap: 6px;
	}
	.la-actions {
		display: flex;
		justify-content: flex-end;
		align-items: center;
		gap: 8px;
	}
	.la-chips {
		display: flex;
		gap: 4px;
		margin-bottom: $dt-spacing-cell-x;
	}
	.la-sub {
		@include dt-type-dense;
		color: $dt-color-ink-faint;
	}
	.la-memo {
		max-width: 320px;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}
	.la-ok {
		color: $dt-color-success-ink;
		font-weight: 600;
	}
	.la-table td {
		white-space: nowrap;
	}
	.la-btns {
		.btn + .btn {
			margin-left: 4px;
		}
	}
	.la-pick {
		max-height: 50vh;
		overflow-y: auto;
		margin-bottom: $dt-spacing-cell-x;
		tr.la-on td {
			background: $dt-color-accent-cell;
		}
	}
	.la-log td {
		white-space: normal;
	}
	.la-pool td {
		white-space: nowrap;
	}
	.la-pool td.la-sub.txt-left {
		white-space: normal;
	}
}
</style>
